import React from 'react';
import './everyday-rewards-in-progress.scss';
import { Button, ButtonColor, ButtonVariant } from '@ampol/design-system';

/**
 * Everyday Rewards In Progress
 * @returns JSX Element
 */
const EverydayRewardsInProgress = ({ onDoneClick }) => {
  return <>
    <div>
      Linking process for Everyday Rewards has been opened in a new browser tab. Please click &apos;Done&apos; once linking is completed.
    </div>
    <Button
      color={ButtonColor.Blue}
      label="Done"
      onClick={onDoneClick}
      variant={ButtonVariant.Primary}
    />
  </>;
};

export default EverydayRewardsInProgress;
